<template>
  <div class="tableBox11">
      <div class="box11Title">待处理作业</div>
      <el-table
        :data="tableData"
        border
        style="width: 98%;margin: auto; height: 243px"
        :header-cell-style="{padding: '9px 3px'}"
        :cell-style="{padding: '8px 3px'}">
        <el-table-column
          prop="num"
          label="编号">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="address"
          label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">审核中</span>
            <span v-if="scope.row.status === 2">待作业</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="noticePerson"
          label="通知人">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="expireBox">
        <el-pagination
          small
          layout="prev, pager, next" @current-change="handleChange"
          :total="total" :current-page="curPage" :page-size="limit">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import { getDclzyList } from "@/api/earlyWarning"
export default {
  name: "zs",
  data() {
    return {
      tableData: [],
      total: 0,
      limit: 5,
      curPage: 1
    }
  },
  methods: {
    getList() {
      getDclzyList({limit: this.limit, curPage: this.curPage}).then(res => {
        // console.log(res)
        this.tableData = res.body.data
        this.cum = res.body.cum
      })
    },
    handleChange(val){
      this.curPage = val
      this.getList()
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
  .tableBox11 {
    width: 49%;
    height: 300px;
    border: 1px solid rgb(232,232,232);
    margin-right: 1%;
    margin-bottom: 10px;
  }
  .box11Title {
    padding-left: 8px;
    font-weight: 600
  }
  .expireBox {
    text-align: right;
    margin-top: 3px
  }
</style>